import { render } from "./CgHardBlockModal.vue?vue&type=template&id=67728aa2&scoped=true"
import script from "./CgHardBlockModal.vue?vue&type=script&lang=js"
export * from "./CgHardBlockModal.vue?vue&type=script&lang=js"

import "./CgHardBlockModal.vue?vue&type=style&index=0&id=67728aa2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67728aa2"]])

export default __exports__